export enum ReviewProvider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  YELP = 'yelp'
}
